module.exports = __webpack_public_path__ + "img/FR10918.d06e999d.png";